<template>
  <div class="combo-list">
    <div class="animated fadeIn">
      <b-row>
        <b-col cols="12">
          <b-card
            header-tag="header"
            footer-tag="footer">
            <div slot="header">
              <i className="fa fa-align-justify"></i><strong class="text-uppercase">{{ $t('combo.combos') }}</strong>
              <div class="pull-right mr-4">
                <button type="button" class="btn btn-success right" @click="createCombo"><i class="fa fa-plus"></i>&nbsp; {{$t('combo.new')}}</button>
              </div>
            </div>
            <b-col cols="12" class="text-center">

              <!-- Start of Filter session -->
              <b-row class="mb-3">
                <b-col xl="12">
                  <div class="pull-right">
                    <b-input-group v-bind:prepend="$t('combo.display_date')">
                      <date-range-picker ref="drange" :startDate="filter.startAt" :endDate="filter.endAt" @update="updateDateRange" opens="left" :locale-data="date_locale" :ranges="ranges"></date-range-picker>
                    </b-input-group>
                  </div>
                  <div class="pull-right mr-2">
                    <button type="button" class="btn bg-main border-radius-4px" @click="onSaleFilter"><i class="fa fa-filter"></i> {{$t('common.on_sale')}}</button>
                  </div>
                </b-col>
              </b-row>
              <b-row class="mb-3">
                <b-col xl="12">
                  <div class="pull-right">
                    <b-input-group v-bind:prepend="$t('combo.active')">
                      <b-form-select v-model="filter.active" v-bind:value="filter.active" :options="statuses[$session.get('lang')]" v-bind:placeholder="$t('combo.active')">
                      </b-form-select>
                    </b-input-group>
                  </div>
                  <div class="pull-right mr-2">
                    <b-input-group v-bind:prepend="$t('combo.status')">
                      <b-form-select v-model="filter.content_status" v-bind:value="filter.content_status" :options="content_statuses[$session.get('lang')]" v-bind:placeholder="$t('combo.status')">
                      </b-form-select>
                    </b-input-group>
                  </div>
                  <div class="pull-right mr-2">
                    <b-input-group v-bind:prepend="$t('common.data')">
                      <b-form-select v-model="filter.publish" v-bind:value="filter.publish" :options="publish_statuses[$session.get('lang')]" v-bind:placeholder="$t('common.data')">
                      </b-form-select>
                    </b-input-group>
                  </div>
                  <div class="pull-right mr-2">
                    <b-input-group v-bind:prepend="$t('combo.display_category')">
                      <b-form-select v-model="filter.display_category" v-bind:value="filter.display_category" :options="display_categories[$session.get('lang')]" v-bind:placeholder="$t('combo.display_category')">
                      </b-form-select>
                    </b-input-group>
                  </div>
                </b-col>
              </b-row>
              <b-row>
                <b-col xl="6">
                  <div class="pull-left mr-2 mb-2">
                    <b-input-group>
                      <button type="button" class="btn bg-main border-radius-4px" v-on:click="publishCombo" variant="success">{{$t('common.publish')}} ({{ids.length}})</button>
                    </b-input-group>
                  </div>
                  <div class="pull-left mr-2 mb-2" v-show="checkShowByConfig('pull_combo_from_pos')">
                    <b-input-group>
                      <button type="button" class="btn bg-main border-radius-4px" v-on:click="pullMenuFromPOS" variant="success">{{$t('common.pull_menu')}}</button>
                    </b-input-group>
                  </div>
                  <div class="pull-left mr-2 mb-2" v-show="checkShowByConfig('import_combo')">
                    <b-input-group>
                      <ImportFile action="import-promos" :submit-text="$t('common.import_combos')" @importFile="importComboWithCsv"></ImportFile>
                    </b-input-group>
                  </div>
                  <div class="pull-left mr-2 mb-2" v-if="checkShowByConfig('import_combo_price')">
                    <b-input-group>
                      <ImportFile action="import-new-prices-combo" :submit-text="$t('common.import_combo_price')" @importFile="importComboPriceWithCsv"></ImportFile>
                    </b-input-group>
                  </div>
                </b-col>
                <b-col xl="6">
                  <b-input-group>
                    <select-dropdown v-bind:options="filter.options" v-bind:selected="filter.selected" position="prepend" v-bind:all="false" v-model="filter.field" prefix="combo">
                    </select-dropdown>
                    <input type="text" class="form-control" v-model="filter.key" v-on:keydown.enter="refreshData"/>
                    <div class="input-group-append">
                      <b-input-group-append>
                        <b-btn @click="refreshData()"><i class="fa fa-search" ></i> {{$t('common.search')}}</b-btn>
                      </b-input-group-append>
                    </div>
                  </b-input-group>
                </b-col>
              </b-row>
              <!-- End of Filter session -->

              <!-- Start of Data table session -->
              <div class="table-responsive combo-data">
                <table class="table table-striped table-hover table-sm table-bordered">
                  <thead>
                  <tr>
                    <th scope="col">
                      <div class="custom-control custom-checkbox">
                        <input id="checkbox1" type="checkbox" class="custom-control-input" @change="selectAll" v-model="allSelected">
                        <label for="checkbox1" class="custom-control-label"></label>
                      </div>
                    </th>
                    <th scope="col">{{$t('combo.release')}}</th>
                    <th scope="col">{{$t('combo.active')}}</th>
                    <th scope="col" v-for="item in dataTable.fields" :class="item.sort?'pointer':''" :key="item.id" @click="updateSort(item.name)" v-show="checkShowByConfig(item.name)">
                      <i class="fa fa-sort-amount-asc text-muted" v-if="dataTable.sort.type == 'asc' && dataTable.sort.field == item.name"></i>
                      <i class="fa fa-sort-amount-desc text-muted" v-if="dataTable.sort.type == 'desc' && dataTable.sort.field == item.name"></i>
                      <span v-if="item.label != null">{{$t('combo.'+item.label)}}</span>
                      <span v-if="item.label == null">{{$t('combo.'+item.name)}}</span>
                    </th>
                    <th scope="col">{{$t('combo.action')}}</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-if="dataTable.items.length == 0">
                    <td class="text-center" :colspan="dataTable.fields.length + 3">
                      {{$t('message.no_data')}}
                    </td>
                  </tr>
                  <tr v-for="item in dataTable.items" :key="item.id">
                    <td scope="row">
                      <div class="custom-control custom-checkbox" v-if="item.content_status == 3">
                        <input :id="'checkbox_item_' + item.id" type="checkbox" class="custom-control-input" v-model="ids" @change="updateAllSeleted" :value="item.id">
                        <label :for="'checkbox_item_' + item.id" class="custom-control-label"></label>
                      </div>
                    </td>
                    <td scope="row">
                      <span v-if="item.publish == 1">{{$t('common.on_fcds')}}</span>
                      <span v-if="item.publish == 0">{{$t('common.non_on_fcds')}}</span>
                    </td>
                    <td scope="row">
                      <c-switch type="icon" variant="success" v-bind="{on: '\uf00c', off: '\uf00d'}" :pill="true" v-model="item.active" :value="1" :uncheckedValue="0" @change="updateStatusItem(item)" />
                    </td>
                    <td scope="row" class="text-left" v-for="field in dataTable.fields" :key="field.id" v-show="checkShowByConfig(field.name)">
                      <span v-if="field.render != null" v-html="field.render(item[field.name], item)"></span>
                      <span v-if="field.render == null">
                        {{item[field.name]}}
                      </span>
                    </td>
                    <td scope="row" width="100">
                      <b-button size="sm" variant="primary" class="btn-margin" v-on:click="editItem(item.uuid)">
                        <i class="fa fa-edit"></i> {{$t('common.edit')}}
                      </b-button>
                      <b-button size="sm" variant="primary" class="btn-margin" v-on:click="cloneItem(item.uuid)">
                        <i class="fa fa-copy"></i> {{$t('common.clone')}}
                      </b-button>
                      <b-dropdown variant="primary" right :text="$tc('order.action')" v-show="combo.config.export_price">
                        <div>
                          <b-dropdown-item  @click="exportItem(item.uuid)"><i class="fa fa-download" aria-hidden="true" style="color:gray"></i>{{$t('common.export')}}</b-dropdown-item>
                        </div>
                      </b-dropdown>
                    </td>
                  </tr>
                  </tbody>
                </table>
              </div>
              <!-- End of Data table session -->

              <!-- Start of paginate session -->
              <b-row>
                <b-col>
                  <b-pagination :total-rows="dataTable.total" :per-page="dataTable.perPage" v-model="dataTable.currentPage" />
                </b-col>
                <b-col class="text-left">
                  {{$t('message.datatable_total', {number: dataTable.items.length, total: dataTable.total})}}
                </b-col>
                <b-col col lg="1">
                  <b-form-select v-model="dataTable.perPage" :options="[10, 20, 50, 100, 200, 500]" class="mb-3"/>
                </b-col>
              </b-row>
              <!-- Start of paginate session -->

            </b-col>
          </b-card>
        </b-col>
      </b-row>
    </div>
  </div>
</template>
<style scoped>
  .custom-checkbox .custom-control-input:checked ~ .custom-control-label::before {
    background-color: #0091ff !important;
    border-radius: 3px !important;
  }
  .custom-control-label::before {
    border-radius: 3px !important;
  }
  .table thead th:nth-child(3){
    width: 100px;
  }
  .btn-margin {
    margin-top: 3px;
    margin-bottom: 3px;
  }
</style>
<script>
import SelectDropdown from '../../../components/Partials/SelectDropdown'
import DataTable from '../../../components/Partials/DataTable'
import DateRangePicker from 'vue2-daterange-picker'
import DatePicker from 'vue2-datepicker'
import cSwitch from '../../../components/Switch'
import axios from 'axios'
import ImportFile from '../../../components/ImportFile'
import * as yup from 'yup'
import { ExportToCsv } from 'export-to-csv'

const CancelToken = axios.CancelToken
let cancel = null
let vm = null

const COMBO_PRICE_FIELDS = ['uuid', 'sku', 'display_price', 'base_price_tier_1', 'base_price_tier_2', 'group_id', 'group_name', 'item_id', 'item_sku', 'item_price_tier_1', 'item_price_tier_2', 'size_sku', 'size_price_tier_1', 'size_price_tier_2', 'crust_sku', 'crust_price_tier_1', 'crust_price_tier_2']
const COMBO_PRICE_SCHEMA =  yup.object().shape({
   uuid: yup.string().required(),
   group_id: yup.string().required(),
   item_id: yup.string().required()
 })

export default {
  name: 'ComboList',
  components: {
    ImportFile,
    SelectDropdown,
    DateRangePicker,
    DatePicker,
    cSwitch,
    DataTable
  },
  data: function () {
    return {
      circle_load: null,
      combo: this.$store.getters.config.gms.combo,
      selected: [],
      allSelected: false,
      ids: [],
      confirmText: {},
      languages: {},
      type: 'like',
      date: [],
      publish_statuses: [],
      statuses: [],
      content_statuses: [],
      display_categories: [],
      filter: {
        options: [],
        selected: null,
        startAt: this.$moment().format('YYYY-MM-DD'),
        endAt: this.$moment().add(3, 'months').format('YYYY-MM-DD'),
        date: [],
        active: 1,
        publish: '',
        content_status: '',
        display_category: '',
        field: null,
        key: null,
      },
      dataTable: {
        items: [],
        fields: [
          {
            name: 'id',
            filter: true,
            sort: true,
            render: (data, row) => {
              if (data == null) {
                return ''
              }
              return data
            }
          },
          {
            name: 'display_categories',
            filter: false,
            sort: false,
            render: (data, row) => {
              if (row.display_categories == null) {
                return ''
              }
              let result = []
              for (let i in data) {
                result.push(data[i].name[this.$session.get('lang')])
              }
              return result.join('<br/>')
            }
          },
          {
            name: 'name',
            label: 'marketing_name',
            filter: true,
            sort: true,
            render: (data, row) => {
              if (data == null) {
                return ''
              }
              return data[this.$session.get('lang')]
            }
          },
          {
            name: 'sku',
            filter: true,
            sort: true,
            render: (data, row) => {
              if (data == null) {
                return ''
              }
              return data
            }
          },
          {
            name: 'content_status',
            filter: false,
            sort: true,
            render: (data, row) => {
              if (data == null) {
                return ''
              }

              for (let i in vm.content_statuses[this.$session.get('lang')]) {
                if (data == vm.content_statuses[this.$session.get('lang')][i].value) {
                  return vm.content_statuses[this.$session.get('lang')][i].text
                }
              }
              return ''
            }
          },
          {
            name: 'display_start',
            label: 'display_date',
            filter: false,
            sort: true,
            render: (data, row) => {
              if (data == null) {
                return ''
              }

              let start = row.display_start
              let end = row.display_end
              return this.$moment(start, 'YYYY-MM-DD HH:mm:ss').format(this.$store.getters.config.main.date_format ? this.$store.getters.config.main.date_format.toUpperCase() : 'DD-MM-YYYY') + ' ~ ' + this.$moment(end, 'YYYY-MM-DD HH:mm:ss').format(this.$store.getters.config.main.date_format ? this.$store.getters.config.main.date_format.toUpperCase() : 'DD-MM-YYYY')
            }
          },
          {
            name: 'created_at',
            filter: false,
            sort: true,
            render: (data, row) => {
              if (data == null) {
                return ''
              }

              data = this.convertUTCToClientTime(data)
              return this.$moment(data, 'YYYY-MM-DD HH:mm:ss').format(this.$store.getters.config.main.date_format ? this.$store.getters.config.main.date_format.toUpperCase() + " HH:mm:ss" : 'DD-MM-YYYY HH:mm:ss')
            }
          }
        ],
        sort: {
          field: 'updated_at',
          type: 'desc'
        },
        currentPage: 1,
        total: 0,
        perPage: 20,
        source: null
      },
      item: {},
      csvMenuExclusionsOptions: {
        fieldSeparator: ',',
        filename: '',
        quoteStrings: '"',
        decimalSeparator: '.',
        showLabels: true,
        showTitle: false,
        useTextFile: false,
        useBom: true,
        useKeysAsHeaders: false,
        headers: []
      }
    }
  },
  methods: {
    checkShowByConfig (key) {
      if (this.combo == null) {
        return true
      }
      let config = this._.find(this.combo.basic_info, function (o) {
        return o.type === key
      })
      if (config == null) {
        return true
      }
      return config.show
    },
    onSaleFilter () {
      this.filter.startAt = this.$moment().format('YYYY-MM-DD')
      this.filter.endAt = this.$moment().add(99, 'years').format('YYYY-MM-DD')
      this.filter.active = 1
      this.filter.content_status = 4
      this.refreshData()
    },
    selectAll: function () {
      if (vm.allSelected == true) {
        for (let i in vm.dataTable.items) {
          if (vm.ids.indexOf(vm.dataTable.items[i].id) === -1 && vm.dataTable.items[i].content_status == 3) {
            vm.ids.push(vm.dataTable.items[i].id)
          }
        }
      } else {
        let ids = []
        for (let j in vm.ids) {
          let exist = false
          for (let i in vm.dataTable.items) {
            if (vm.dataTable.items[i].id == vm.ids[j]) {
              exist = true
              break
            }
          }

          if (!exist) {
            ids.push(vm.ids[j])
          }
        }
        vm.ids = vm._.cloneDeep(ids)
      }
    },
    updateAllSeleted: function () {
      let total = 0
      for (let j in vm.ids) {
        for (let i in vm.dataTable.items) {
          if (vm.dataTable.items[i].id == vm.ids[j] && vm.dataTable.items[i].content_status == 3) {
            total += 1
            break
          }
        }
      }

      let itemLength = 0

      for (let i in vm.dataTable.items) {
        if (vm.dataTable.items[i].content_status == 3) {
          itemLength += 1
        }
      }

      if (itemLength == total && itemLength > 0) {
        vm.allSelected = true
      } else {
        vm.allSelected = false
      }
    },
    publishCombo () {
      let profileId;
      if(this.filter.display_category && vm.combo.config.publish_etl) {
        let displayCategory = vm.display_categories[this.$session.get('lang')].find(displayCategory => {
          return displayCategory.value == vm.filter.display_category
        })
        if(displayCategory) {
          profileId = displayCategory.text;
        }
      }
      console.log('pushlish',{
                  'scope': 'partial',
                  'bulk': vm.ids,
                  'trigger_sqs': vm.combo.config.publish_etl ? 1 : 0,
                  'profileId' : profileId
                })
      vm.axios.menu.publishCombo({
        'scope': 'partial',
        'bulk': vm.ids,
        'trigger_sqs': vm.combo.config.publish_etl ? 1 : 0,
        'profileId' : profileId
      }, function (response) {
        vm.$toastr.success(vm.$t('message.update_successful'), vm.$t('message.success'), {})
        vm.ids = []
        vm.refreshData()
      })
    },
    pullMenuFromPOS () {
      vm.axios.menu.pullMenuFromPos({
        'scope': 'partial',
        'action': 'pull_combo_from_pos',
        'bulk': vm.ids
      }, function (response) {
        vm.$toastr.success(vm.$t('message.update_successful'), vm.$t('message.success'), {})
        vm.ids = []
        vm.refreshData()
      })
    },
    /**
     * convert date format then refresh data when date range update
     * @param val
     */
    updateDateRange (val) {
      this.date = val
      this.filter.startAt = val.startDate != null ? this.$moment(val.startDate).format('YYYY-MM-DD') : this.$moment().subtract(7, 'days').format('YYYY-MM-DD')
      this.filter.endAt = val.endDate != null ? this.$moment(val.endDate).format('YYYY-MM-DD') : this.$moment().format('YYYY-MM-DD')
      this.refreshData()
    },
    /**
     * update sort field and sort type then refresh data
     * @param field
     */
    updateSort (field) {
      for (let i in this.dataTable.fields) {
        if (this.dataTable.fields[i].name == field && (this.dataTable.fields[i].sort == null || this.dataTable.fields[i].sort == false)) {
          return
        }
      }
      if (this.dataTable.sort.field != field) {
        this.dataTable.sort = {
          field: field,
          type: 'asc'
        }
      } else {
        if (this.dataTable.sort.type == 'asc') {
          this.dataTable.sort = {
            field: field,
            type: 'desc'
          }
        } else {
          this.dataTable.sort = {
            field: field,
            type: 'asc'
          }
        }
      }

      this.refreshData()
    },
    /**
     * refresh data for data table
     */
    refreshData () {
      if (cancel != null) {
        cancel()
      }
      // get params
      let _data = {
        page: this.dataTable.currentPage,
        limit: this.dataTable.perPage,
        sort_field: this.dataTable.sort.field,
        sort_type: this.dataTable.sort.type,
        start: this.filter.startAt,
        end: this.filter.endAt
      }

      if (this.filter.display_category != '') {
        _data['display_category_id'] = this.filter.display_category
      }

      if (this.filter.active != '') {
        _data['active'] = this.filter.active
      }

      if (this.filter.publish != '') {
        _data['publish'] = this.filter.publish
      }

      if (this.filter.content_status != '') {
        _data['content_status'] = this.filter.content_status
      }
      if (!this._.isEmpty(this.filter.field) && !this._.isEmpty(this.filter.key)) {
        _data[this.filter.field] = this.filter.key.trim()
      }

      //process to send via get method
      let params = '';
      for (let key in _data) {
        params += key+'='+_data[key]+'&'
      }
      //remove tail
      params = params.slice(0, -1)
      vm.axios.menu.getComboList(params, function(response){
        vm.dataTable.items = response.data.data.items
        vm.dataTable.total = response.data.data.pagination.total
        vm.updateAllSeleted()
      })
    },
    /**
     * move to detail page by uuid
     * @param uuid
     */
    editItem (uuid) {
      vm.$router.push({name: 'combo_edit', params: { uuid: uuid }})
    },
    /**
     * Clone Combo by uuid
     * @param uuid
     */
    cloneItem (uuid) {
      const vm = this;
      const params = {
        uuid
      }
      vm.axios.cloneCombo(params, function () {
          vm.refreshData()
      })
    },
    /**
     * update status by uuid
     * @param uuid and status
     */
    updateStatusItem (item) {
      let params = {
        uuid: item.uuid,
        active: item.active,
        content_status: 3,
        isSeoName: vm.checkShowByConfig('friendly_seo_name')
      }
      vm.axios.menu.updateComboStatus(params, function(response){
        vm.$toastr.success(vm.$t('message.update_successful'), vm.$t('message.success'), {})
        vm.refreshData()
      });
    },
    createCombo: function(){
      vm.$router.push({name: 'combo_create', params: { id: 'create' }})
    },

    /**
     * get list categories for select box
     */
    getListCategories () {
      vm.axios.menu.getListSimpleDisplayCategories('level=1', function (response) {
        vm.display_categories = []
        let langs = vm.$store.getters.languages
        for (let l in langs) {
          vm.publish_statuses[langs[l]] = [
            {text: vm.$t('common.all', langs[l]), value: ''},
            {text: vm.$t('common.on_fcds', langs[l]), value: '1'},
            {text: vm.$t('common.non_on_fcds', langs[l]), value: '0'}
          ]
          vm.statuses[langs[l]] = [
            {text: vm.$t('common.all', langs[l]), value: ''},
            {text: vm.$t('common.active', langs[l]), value: '1'},
            {text: vm.$t('common.inactive', langs[l]), value: '0'}
          ]
          vm.content_statuses[langs[l]] = [
            {text: vm.$t('common.all', langs[l]), value: ''},
            {text: vm.$t('combo.new', langs[l]), value: 1},
            {text: vm.$t('combo.editing', langs[l]), value: 2},
            {text: vm.$t('combo.ready_to_publish', langs[l]), value: 3},
            {text: vm.$t('combo.published', langs[l]), value: 4},
            {text: vm.$t('combo.publishing', langs[l]), value: 75},
            {text: vm.$t('combo.published_fail', langs[l]), value: 99}
          ]
          vm.confirmText[langs[l]] = vm.$t('date_range.text_apply', langs[l])
          vm.languages[langs[l]] = {
            'days': [
              vm.$t('date_range.sun', langs[l]),
              vm.$t('date_range.mon', langs[l]),
              vm.$t('date_range.tue', langs[l]),
              vm.$t('date_range.wed', langs[l]),
              vm.$t('date_range.thu', langs[l]),
              vm.$t('date_range.fri', langs[l]),
              vm.$t('date_range.sat', langs[l])
            ],
            'months': [
              vm.$t('date_range.month_1', langs[l]),
              vm.$t('date_range.month_2', langs[l]),
              vm.$t('date_range.month_3', langs[l]),
              vm.$t('date_range.month_4', langs[l]),
              vm.$t('date_range.month_5', langs[l]),
              vm.$t('date_range.month_6', langs[l]),
              vm.$t('date_range.month_7', langs[l]),
              vm.$t('date_range.month_8', langs[l]),
              vm.$t('date_range.month_9', langs[l]),
              vm.$t('date_range.month_10', langs[l]),
              vm.$t('date_range.month_11', langs[l]),
              vm.$t('date_range.month_12', langs[l])
            ],
            'pickers': [
              vm.$t('date_range.next_7_days', langs[l]),
              vm.$t('date_range.next_30_days', langs[l]),
              vm.$t('date_range.pre_7_days', langs[l]),
              vm.$t('date_range.pre_30_days', langs[l]),
            ],
            'placeholder': {
              'date': vm.$t('date_range.select_date', langs[l]),
              'dateRange': vm.$t('date_range.select_range', langs[l])
            }
          }
          vm.display_categories[langs[l]] = [{
            text: vm.$t('common.all', langs[l]),
            value: ""
          }]
          for (let c in response.data.data.items) {
            vm.display_categories[langs[l]].push({
              text: response.data.data.items[c]['name'][langs[l]] != null ? response.data.data.items[c]['name'][langs[l]] : '',
              value: response.data.data.items[c]['id']
            })
          }
        }
      })
    },
    importComboWithCsv(file, action) {
      if(!file) {
        return
      }

      let formData = new FormData()
      formData.append('file', file)
      formData.append('action', action)
      const config = {headers: {'Content-Type': 'multipart/form-data'}}

      vm.axios.menu.importMenuWithCsv(formData, config, function (response) {
        vm.$toastr.success(vm.$t('message.update_successful'), vm.$t('message.success'), {})
        vm.ids = []
        vm.refreshData()
      })
    },
    async importComboPriceWithCsv(file, action) {
      if(!file) {
        return
      }
      const valid = await vm.validatePriceCsv(file, COMBO_PRICE_FIELDS, COMBO_PRICE_SCHEMA)
      if(valid.is_empty || valid.is_missing_field || valid.errors.length > 0) {
        if(valid.is_missing_field) {
          vm.$toastr.error('', vm.$t('message.upload_menu_price_csv_missing_field', { fields: valid.errors[0] }),{})
        } else {
          vm.$toastr.error('', vm.$t('message.upload_menu_price_csv_failed'), {})
        }
        return
      }

      let formData = new FormData()
      formData.append('file', file)
      formData.append('action', action)
      const config = {headers: {'Content-Type': 'multipart/form-data'}}

      vm.axios.menu.importMenuPriceWithCsv(formData, config, function (response) {
        vm.$toastr.success('', vm.$t('message.upload_menu_price_csv_successful'), {})
        vm.ids = []
        vm.refreshData()
      })
    },
    /**
     * clone menu by uuid
     * @param uuid
     */
    exportItem(uuid) {
      const vm = this;
      const params = {
        uuid,
        type: 'combos'
      };
      vm.axios.exportMenu(params, async function (response) {
        let dataExport = (response.data && response.data.data.items) || []
        if (dataExport && dataExport.length > 0) {
          vm.csvMenuExclusionsOptions.filename = `${dataExport[0].sku}_${dataExport[0].name}`
          vm.csvMenuExclusionsOptions.headers = Object.keys(dataExport[0])

          let csvExporter = new ExportToCsv(vm.csvMenuExclusionsOptions)
          csvExporter.generateCsv(dataExport)
        } else {
          vm.$toastr.error(vm.$t('message.export_menu_exclusion_no_data'), vm.$t('message.success'), {})
        }
      })
    },
  },
  created: function () {
    this.debouncedInput = _.debounce(this.refreshData, 240)
    vm = this
    let CancelToken = vm.axios.CancelToken
    vm.dataTable.source = CancelToken.source()
    // Add aggregator_code and name_seo for Peru
    if (vm.$store.getters.config.country_code === 'PE') {
      vm.dataTable.fields.push(
        {
          name: 'aggregator_code',
          filter: true,
          sort: true,
          render: (data) => data !== null ? data : ''
        },
        {
          name: 'short_name',
          filter: true,
          sort: true,
          render: (data) => data || ''
        }
      )
    }

    for (let i in vm.dataTable.fields) {
      let field = vm.dataTable.fields[i].name

      if (vm.dataTable.fields[i].filter != null && vm.dataTable.fields[i].filter == true && this.checkShowByConfig(this.dataTable.fields[i].name)) {
        vm.filter.options.push(vm.dataTable.fields[i])
      }
      if (vm.dataTable.fields[i].sort != null && vm.dataTable.fields[i].sort == true && vm.dataTable.sort.field == null) {
        vm.dataTable.sort = {
          field: field,
          type: 'asc'
        }
      }
    }
    vm.$Progress.start()
    vm.getListCategories()
    let filter = this.$session.get('filter', null)
    if (filter != null && this.$route.query && this.$route.query.rollback) {
      for (let i in filter.filter) {
        this.filter[i] = filter.filter[i]
      }
      for (let i in filter.dataTable) {
        this.dataTable[i] = filter.dataTable[i]
      }
    }
    vm.refreshData()
  },
  beforeDestroy: function () {
    if (vm.circle_load != null) {
      clearInterval(vm.circle_load)
      vm.circle_load = null
    }
    this.$session.set('filter', {
      filter: this.filter,
      dataTable: {
        sort: {
          field: this.dataTable.sort.field,
          type: this.dataTable.sort.type
        },
        currentPage: this.dataTable.currentPage,
        perPage: this.dataTable.perPage
      }
    })
  },
  watch: {
    'filter.key': function (val) {
      this.debouncedInput()
    },
    'dataTable.currentPage': function (val) {
      vm.refreshData()
    },
    'dataTable.perPage': function (val) {
      vm.refreshData()
    },
    'filter.active': function (val) {
      vm.refreshData()
    },
    'filter.display_category': function (val) {
      vm.refreshData()
    },
    'filter.content_status': function (val) {
      vm.refreshData()
      if (vm.filter.content_status == 75) {
        vm.circle_load = setInterval(() => {
          vm.refreshData()
        }, 5000)
      } else {
        if (vm.circle_load != null) {
          clearInterval(vm.circle_load)
          vm.circle_load = null
        }
      }
    },
    'filter.publish': function (val) {
      vm.refreshData()
    }
  },
  computed : {
    date_locale : function () {
      let format = this.format_date_range_locale()
      if(this.$refs.drange){
        this.$refs.drange.locale = format
      }
      return format
    },
    ranges : function () {
      return this.format_date_ranges()
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/views/admin/combo/List.vue